import * as CL from '@design-system/component-library';
import { paths } from '../../../common/constants/pathVariables.js';
import {
  consumerCustomersMsg,
  corporateCustomersMsg,
  emailMsg,
  employeeOmaElisaMsg,
  logInMsg,
  omaElisaClassicMsg,
  omaElisaForCompaniesMsg,
  shopMsg,
  t,
} from '../../../common/i18n/index.js';
import type * as CLT from '@design-system/component-library';
import type {
  ServiceMenuLinkCategoryItemProps,
  ServicesMenuLinkCategoryProps,
} from '@design-system/component-library/src/components/Header/subcomponents/HeaderServicesMenu/HeaderServicesMenu';
import type { SyntheticEvent } from 'react';
import type { NavigateFunction } from 'react-router';

export const loginLinks = (
  navigate: NavigateFunction,
  ssoSessionValid: boolean
): Exclude<CLT.HeaderUserMenuProps['userMenuLinkAccordions'], undefined> | undefined => {
  if (ssoSessionValid) {
    // if authenticated and on the public side we don't want to show the login links in user menu
    return undefined;
  }
  return [
    {
      items: [
        {
          onClick: e => {
            e.preventDefault();
            navigate(paths.SELF_SERVICE_HOME);
          },
          icon: <CL.Icon icon="office" />,
          title: t.LOUS(omaElisaForCompaniesMsg),
          url: paths.SELF_SERVICE_HOME,
        },
        {
          onClick: e => {
            e.preventDefault();
            navigate(paths.EMPLOYEE_HOME);
          },
          icon: <CL.Icon icon="user" />,
          title: t.S0FN(employeeOmaElisaMsg),
          url: paths.EMPLOYEE_HOME,
        },
        {
          icon: <CL.Icon icon="external-link" />,
          title: t.SLBP(omaElisaClassicMsg),
          url: 'https://oma.elisa.fi/yrityksille',
        },
      ],
      onToggle: () => {},
      order: 1,
      title: t.HYV2(logInMsg),
      toggled: true,
    },
  ];
};

export const headerAccordions = (
  navigate: NavigateFunction,
  ringBaseUrl: string,
  onClick?: (e: SyntheticEvent, url: string) => void
): ServicesMenuLinkCategoryProps[] => {
  const corporateItems: ServiceMenuLinkCategoryItemProps[] = [
    {
      title: t.LOUS(omaElisaForCompaniesMsg),
      url: paths.SELF_SERVICE_HOME,
      icon: <CL.Icon icon="office" />,
    },
    {
      title: t.S0FN(employeeOmaElisaMsg),
      url: paths.EMPLOYEE_HOME,
      icon: <CL.Icon icon="group" />,
    },
    {
      title: t.SLBP(omaElisaClassicMsg),
      url: 'https://oma.elisa.fi/yrityksille',
      icon: <CL.Icon icon="external-link" />,
    },
    {
      onClick: (e: SyntheticEvent) => {
        e.preventDefault();
        if (onClick) {
          onClick(e, paths.WEB_SHOP);
        } else {
          navigate(paths.WEB_SHOP);
        }
      },
      title: t.BZYZ(shopMsg),
      url: paths.WEB_SHOP,
      icon: <CL.Icon icon="cart" />,
    },
    {
      title: 'OmaRing',
      url: `${ringBaseUrl}/autologin`,
      icon: <CL.Icon icon="phone" />,
    },
    {
      title: 'Elisa Fokus',
      url: 'https://fokus.elisa.fi',
      icon: <CL.Icon icon="display" />,
    },
    {
      title: t.OKYY(emailMsg),
      url: 'https://webmail.elisa.fi',
      icon: <CL.Icon icon="email" />,
    },
    {
      onClick: (e: SyntheticEvent) => {
        e.preventDefault();
        navigate('/yritys-palvelut');
      },
      icon: <CL.Icon icon="more" />,
      title: t.BU57('All corporate services'),
      url: '/yritys-palvelut',
    },
  ];

  const consumerItems: ServiceMenuLinkCategoryItemProps[] = [
    {
      icon: <CL.Icon icon="user" />,
      title: 'OmaElisa',
      url: 'https://verkkoasiointi.elisa.fi',
    },
    {
      icon: <CL.Icon icon="email-address" />,
      title: t.OKYY(emailMsg),
      url: 'https://webmail.elisa.fi',
    },
    {
      icon: <CL.Icon icon="display" />,
      title: 'Elisa Viihde',
      url: 'https://elisaviihde.fi',
    },
    {
      icon: <CL.Icon icon="cart" />,
      title: t.BZYZ(shopMsg),
      url: 'https://elisa.fi/kauppa',
    },
  ];

  return [
    {
      title: t.ANXA(corporateCustomersMsg),
      order: 1,
      toggled: true,
      items: corporateItems,
    },
    {
      title: t.CDCD(consumerCustomersMsg),
      order: 2,
      toggled: false,
      items: consumerItems,
    },
  ];
};
